import { Component } from "react";
import { Modal, Checkbox, message, Button, Row } from "antd";
import { companiesService } from "./../../redux/services";

class ModalRequest extends Component {
  state = {
    types: [],
    loading: false,
  };

  onOpen = () => {
    this.setState({
      types: [],
      loading: false,
    });
  };

  handleSubmit = () => {
    const { types } = this.state;
    const { company } = this.props;

    if (types.length === 0) {
      message.warning("Selecione pelo menos um tipo de atestado.");
      return;
    }

    this.setState({ loading: true });

    companiesService
      .requestFile({
        uuid: company.uuid,
        types: types,
      })
      .then(() => {
        message.success("Solicitação enviada com sucesso!");
        this.props.onClose();
      })
      .catch((err) => {
        message.error("Ocorreu um erro ao solicitar o atestado.");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleCheckboxChange = (checkedValues) => {
    this.setState({ types: checkedValues });
  };

  render() {
    const { visible, onClose } = this.props;

    return (
      <Modal
        title="Solicitar Atestado de Software"
        visible={visible}
        onCancel={onClose}
        footer={[
          <Button key="cancel" onClick={onClose}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={this.state.loading}
            onClick={this.handleSubmit}
          >
            Enviar Solicitação
          </Button>,
        ]}
        centered
        destroyOnClose
      >
        <Checkbox.Group
          value={this.state.types}
          onChange={this.handleCheckboxChange}
        >
          <Row>
            <Checkbox value="REP-P">REP-P</Checkbox>
          </Row>

          <Row>
            <Checkbox value="PTRP">PTRP</Checkbox>
          </Row>
        </Checkbox.Group>
      </Modal>
    );
  }
}

export default ModalRequest;
